var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEconomy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.07 36.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-linejoin:round;}.cls-1,.cls-2{fill:none;stroke:#fff;stroke-linecap:round;stroke-width:2px;}.cls-2{stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1349",
    transform: "translate(-803 -936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "board-30-outline-64",
    transform: "translate(804 937)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_358",
    className: "cls-1",
    x: 16.57,
    y: 9.76,
    width: 3.41,
    height: 11.19
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_359",
    className: "cls-1",
    x: 9.27,
    y: 16.57,
    width: 3.41,
    height: 4.38
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_360",
    className: "cls-1",
    x: 23.88,
    y: 13.65,
    width: 3.41,
    height: 7.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_6",
    className: "cls-2",
    x1: 18.03,
    y1: 27.28,
    x2: 18.03,
    y2: 34.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_7",
    className: "cls-2",
    x1: 14.63,
    y1: 27.28,
    x2: 7.81,
    y2: 35.56
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_8",
    className: "cls-2",
    x1: 21.44,
    y1: 27.28,
    x2: 28.26,
    y2: 35.56
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_411",
    className: "cls-1",
    d: "M31.87,23.92V3.97H4.5V23.92"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_9",
    className: "cls-2",
    x1: 35.07,
    y1: 27.28,
    x2: 1,
    y2: 27.28
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_10",
    className: "cls-2",
    x1: 18.03,
    y1: 3.92,
    x2: 18.03,
    y2: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEconomy);
export default __webpack_public_path__ + "static/media/economy.51549d5da0f0c0e0e7b727011e7f624a.svg";
export { ForwardRef as ReactComponent };